var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.68,57.842h-1.412V29.863c0-1.104-0.896-2-2-2H26.732c-1.104,0-2,0.896-2,2v27.979H23.32c-1.104,0-2,0.896-2,2v3.796 c0,2.481,2.019,4.5,4.5,4.5H70.18c2.481,0,4.5-2.019,4.5-4.5v-3.796C74.68,58.737,73.784,57.842,72.68,57.842z M28.732,31.863 h38.535v25.979H28.732V31.863z M70.68,63.638c0,0.275-0.225,0.5-0.5,0.5H25.82c-0.276,0-0.5-0.225-0.5-0.5v-1.796h1.412h42.535 h1.412V63.638z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.cf933d8f90d5fb5c444d0e7d88804cb0.svg";
export { ForwardRef as ReactComponent };